let apiUrl = "";
const domainName = window.location.host;

console.log("api url inside apiUrl is ", domainName)

if (domainName === 'localhost:3000') {
    // apiUrl = 'https://developer.sandbox.eddflix.com/api/v1/'
    // apiUrl = 'http://localhost:5001/api/v2/'
    // apiUrl = 'http://localhost:5002/api/v2/eddflix/'
    apiUrl = 'http://localhost:5002/api/v2/'
    // apiUrl = 'http://44.233.43.219:5002/api/v2/'


    // apiUrl = 'https://developer.sandbox.eddflix.com/api/v2/'
}
else if (domainName === '44.233.43.219:3000') {
    // apiUrl = 'https://localhost:5002/api/v2/'
    apiUrl = 'http://44.233.43.219:5002/api/v2/'
}
else {
    // apiUrl = 'https://localhost:5002/api/v2/'
    apiUrl = 'http://44.233.43.219:5002/api/v2/'
}


export default apiUrl;